import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { WorkflowItemProps } from "apis/workflow";
import { PaginationProps } from "utils/types/API";

export interface WorkflowState {
    loading: boolean;
    list: {
        data: WorkflowItemProps[];
        options: WorkflowItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: WorkflowItemProps;
    };
}

const initialState: WorkflowState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: WorkflowItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: WorkflowItemProps;
}
export const workflowSlice = createSlice({
    name: "workflow",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = workflowSlice.actions;
export default workflowSlice.reducer;
